import React, { useEffect } from 'react';
import Webcam from 'react-webcam';
import { useRef, useState, useCallback } from 'react';
import { Box, Button, Typography, IconButton, Stack } from '@mui/material';

import * as tf from '@tensorflow/tfjs';
import '@tensorflow/tfjs-backend-webgl';
import * as facemesh from '@tensorflow-models/face-landmarks-detection';
import * as blazeface from '@tensorflow-models/blazeface';

import { AiFillCamera } from 'react-icons/ai';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Link } from 'react-router-dom';
import { MdCameraAlt, MdFlipCameraIos, MdOutlineClose } from 'react-icons/md';
import Loader from '../../global/Loader';
import { useTranslation } from 'react-i18next';

const BASE_URL = process.env.REACT_APP_BASE_URL;

function WebcamCaptureSimpleForMobile({
  imageSrc,
  setImageSrc,
  handleDocSelfieContinue,
  iconButtonHandler
}) {
  // function WebcamCaptureFullMode() {
  console.log('imageSrcimageSrc', imageSrc);
  const urlParams = new URLSearchParams(window.location.search);
  const ocrType = urlParams.get('ocrType');
  const docCode = urlParams.get('document_code');

  const { t } = useTranslation();
  const cameraSoundRef = useRef(null);
  const [mirrorValue, setMirrorValue] = useState(false);
  const [openloader, setOpenloader] = useState(false);
  const [imageSrcBase64Custom, setImageSrcBase64Custom] = useState(null);

  const nonOcrDocRef = useRef();

  const [docCameraInterVal, setdocCameraInterVal] = useState(null);

  const capture = useCallback(
    (docCameraInterVal) => {
      if (docCameraInterVal) {
        clearInterval(docCameraInterVal.docCameraInterValId);
      }
      const imageSrcBase64 = nonOcrDocRef.current.getScreenshot();
      console.log('imageSrcBase64', imageSrcBase64);
      if (imageSrcBase64) {
        const urlParams = new URLSearchParams(window.location.search);
        const docCode = urlParams.get('document_code');
        const file = new File([imageSrcBase64], `_${docCode}.jpg`, {
          type: imageSrcBase64.type,
          lastModified: new Date().getTime()
        });
      }

      if (cameraSoundRef.current) {
        cameraSoundRef.current.play(); // camera sound, when clicked image
        setOpenloader(true);
        //  close window of nonOcr camera
        setTimeout(() => {
          setOpenloader(false);
          handleDocSelfieContinue(imageSrcBase64, 'isMobile');
        }, 1000);
      }
    },
    [nonOcrDocRef]
  );

  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [videoConstraints, setVideoConstrain] = useState({
    facingMode: window.screen.width < 993 ? 'user' : 'environment'
    // width: window.screen.width < 993 ? window.screen.width : 500,
    // height: window.screen.width < 993 ? window.screen.height - 300 : '',
  });

  const switchCameraFace = (videoConstraints) => {
    if (videoConstraints?.facingMode === 'environment') {
      setVideoConstrain({
        facingMode: 'user'
      });
    } else {
      setVideoConstrain({
        facingMode: 'environment'
      });
    }
  };

  // file or browse file from system
  // const handleFileUpload = (e) => {
  //   const file = e.target.files[0]; // blob file use to make base64 image
  //   const blobSimple = e.target.files[0]; // blob file use directly to rename blob
  //   if (file || blobSimple) {
  //     // modified new file structure with the name
  //     const ImageFile = new File([blobSimple], `_${docCode}.jpg`, {
  //       type: blobSimple.type,
  //       lastModified: new Date().getTime()
  //     });
  //     // modified new file structure with the name end
  //     // convert into base64
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       // console.log('handleFileUpload', { img: reader.result, file: ImageFile });
  //       setImageSrc({ img: reader.result, file: ImageFile });
  //       setImageSrcBase64Custom(reader.result);
  //     };
  //     reader.readAsDataURL(file);
  //   }

  //   setTimeout(() => {
  //     handleDocSelfieContinue(
  //       imageSrcBase64Custom !== null ? imageSrcBase64Custom : '',
  //       'isMobile'
  //     );
  //   }, 500);
  // };
  // file or browse file from system end

  useEffect(() => {
    // setOpenloader(false);
    const isSafari = window.safari !== undefined;
    const userAgent = window.navigator.userAgent;

    if (isSafari || userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
      setMirrorValue(true);
      // return false;
    } else {
      setMirrorValue(false);
    }
    // by default mirror value is false
  }, []);

  return (
    <>
      <Loader openloader={openloader} />
      <Stack>
        <Box className="containerStyle FullModeCamera">
          <IconButton
            size="small"
            className="closeMarkStyle"
            onClick={(e) => {
              iconButtonHandler(e);
            }}
          >
            <MdOutlineClose size={24} />
          </IconButton>
          <Box className="cameraHeading">{t('Selfie')}</Box>
          {/* {ocrType === 'NonOcr' ? (
            <Box
              className="uploadFile"
              style={{ position: 'static', top: '10px', textAlign: 'center' }}
            >
              <Stack mb={1} style={{ textAlign: 'center' }}>
                <input
                  accept="image/png, image/jpg, image/jpeg"
                  className="fileInput mainBtn"
                  id="contained-button-file1"
                  type="file"
                  onChange={(e) => handleFileUpload(e)}
                />
              </Stack>
              <Typography mb={1} variant="h7" style={{ textAlign: 'center', display: 'block' }}>
                OR
              </Typography>
            </Box>
          ) : (
            ''
          )} */}

          <Box className="docNonOcrComp">
            <Webcam
              // onUserMedia={(userMedia) => openCvReady(userMedia)}
              audio={false}
              ref={nonOcrDocRef}
              videoConstraints={videoConstraints}
              style={{ opacity: 1 }}
              className="docNonOcrCamOpen"
              id="nonOcrDocVideo"
            />

            {/* <canvas id="canvas_output" ref={nonOcrDocCanvasRef} className="docNonOcrCameraOpenCv" /> */}
            {/* <div className="overlayRecBorderCamera">{recBorder()} </div> */}

            <Box className="cameraIconBox" onClick={handleClickOpen}>
              <Typography variant="span" className="cameraIcon">
                <IconButton
                  size="small"
                  className="cameraIconButton"
                  onClick={(e) => {
                    // cameraSoundRef.current.play();
                    // capture(e, docCameraInterVal);
                    capture(docCameraInterVal);
                    // setGetingCapture(true);
                  }}
                  sx={{ cursor: 'pointer' }}
                >
                  <MdCameraAlt size={20} />
                </IconButton>
              </Typography>
              <Typography variant="span" className="cameraIcon flipIcon">
                <IconButton
                  size="small"
                  className="cameraIconButton"
                  onClick={(e) => {
                    switchCameraFace(videoConstraints);
                  }}
                  sx={{ cursor: 'pointer' }}
                >
                  <MdFlipCameraIos size={20} />
                </IconButton>
              </Typography>
            </Box>
          </Box>

          {/* <Box className="cameraHeading" mt={2}>
            Document Bill
          </Box> */}
        </Box>

        {/* <Box className="cameraIconBox">
          <Box onClick={handleClickOpen}>
            <Typography className="cameraIconLink" onClick={capture} sx={{ cursor: 'pointer' }}>
              <Typography variant="span" className="cameraIcon">
                <AiFillCamera />
              </Typography>
            </Typography>
          </Box>
        </Box> */}

        {/* <Button className="mainBtn" onClick={capture}>Capture photo</Button> */}
        <Box className="cameraSound" style={{ opacity: 0, position: 'absolute' }}>
          <audio controls ref={cameraSoundRef}>
            <source src={`${BASE_URL}/assets/iphone-camera-capture-6448.mp3`} type="audio/mp3" />
            <source src={`${BASE_URL}/assets/iphone-camera-capture-6448.mp3`} type="audio/mp3" />
            <source src={`${BASE_URL}/assets/iphone-camera-capture-6448.ogg`} type="audio/ogg" />
            Your browser does not support the audio element.
          </audio>
        </Box>
        {/* {imgSrc && (
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="popupOuter"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description" className="">
                <img src={imgSrc} className="imageCaptured" />
              </DialogContentText>
            </DialogContent>
            <DialogActions className="popupFooter">
              <Link className="mainBtn" onClick={() => handleContinue(imgSrc)}>
                Continue
              </Link>
              <Button className="mainBtn" onClick={handleClose}>
                New Shoot
              </Button>
            </DialogActions>
          </Dialog>
        )} */}
      </Stack>
    </>
  );
}

export default WebcamCaptureSimpleForMobile;
